module.exports = __webpack_public_path__ + "img/xmasParty18.b4754d6e.jpg";